import { LEReportData, ReportScore, ReportTreeNode } from '../types';
import { flattenTree, updateScoreData } from './CommonReportHelper';

export const flattenSkillTree = (skillTree: ReportTreeNode) => {
  return flattenTree(skillTree);
};

export const fillSkillScoreData = (
  skillScoreData: LEReportData,
  skillReportData: LEReportData,
  skillTree: ReportTreeNode,
) => {
  // Step 1: Update only the exact matching leaf nodes (skills from skillReportData)
  const updateLeafNodes = (node: ReportTreeNode, userId: string) => {
    const nodeIdStr = `${node.id}`;
    const skillScoreObj = skillReportData?.[userId]?.[nodeIdStr] as ReportScore;

    // If this node has data in skillReportData, update it
    if (skillScoreObj) {
      updateScoreData(skillScoreData, userId, nodeIdStr, skillScoreObj);
    }

    // Recursively process all subNodes
    node.subNodes.forEach((subNode) => {
      updateLeafNodes(subNode, userId);
    });
  };

  // Step 2: Aggregate scores from children to parents (bottom-up)
  const aggregateToParents = (node: ReportTreeNode, userId: string) => {
    // First, recursively process all children
    node.subNodes.forEach((subNode) => {
      aggregateToParents(subNode, userId);
    });

    // Then, aggregate children's scores into this parent node
    if (node.subNodes.length > 0) {
      const nodeIdStr = `${node.id}`;
      node.subNodes.forEach((subNode) => {
        const childIdStr = `${subNode.id}`;
        const childScore = skillScoreData[userId]?.[childIdStr];
        if (childScore) {
          updateScoreData(skillScoreData, userId, nodeIdStr, childScore);
        }
      });
    }
  };

  // Process each user
  const userIds = Object.keys(skillReportData);
  userIds.forEach((userId) => {
    // First pass: Update leaf nodes only
    updateLeafNodes(skillTree, userId);

    // Second pass: Aggregate from children to parents
    aggregateToParents(skillTree, userId);
  });

  return skillScoreData;
};
